module.exports = __webpack_public_path__ + "static/media/fauna_1.25bbcdcc.png";